import axios from './base'
const url = `/mine`

export function changePassword(data = {}) {
  return axios.request({
    url: `${url}/change/password`,
    method: "post",
    data,
  })
}

export function getProfile(data = {}) {
  return axios.request({
    url: `${url}/info`,
    method: "get",
    params: data,
  })
}

export function updateProfile(data = {}) {
  return axios.request({
    url: `${url}/info`,
    method: "put",
    data,
  })
}